export const assessmentRegions = {
  'top-left': [{ type: 'title_element' }],
  right: [{ type: 'accessibility_button' }, { type: 'flagitem_button' }, { type: 'notepad_button' }],
  items: [
    {
      type: 'progress_element',
    },
    {
      type: 'slider_element',
    },
  ],
  'bottom-right': [{ type: 'horizontaltoc_element' }, { type: 'next_button' }],
};
